import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from "@mui/material";
import create from "zustand";
import { useTranslation } from "react-i18next";

type ConfirmDialogStore = {
    message: string;
    onSubmit?: () => void;
    close: () => void;
};

const useConfirmDialogStore = create<ConfirmDialogStore>((set) => ({
    message: "",
    onSubmit: undefined,
    close: () => set({ onSubmit: undefined }),
}));

export const confirmDialog = (message: string, onSubmit: () => void) => {
    useConfirmDialogStore.setState({
        message,
        onSubmit,
    });
};

const ConfirmDialog = () => {
    const { message, onSubmit, close } = useConfirmDialogStore();
    const { t } = useTranslation();
    return (
        <Dialog open={Boolean(onSubmit)} onClose={close} maxWidth="sm" fullWidth>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <DialogTitle>{t("shared.confirm.areYouSure")}</DialogTitle>
            </Box>
            <DialogContent>{message}</DialogContent>
            <DialogActions>
                <Button color="primary" variant="contained" onClick={close}>
                    {t("shared.confirm.cancel")}
                </Button>
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={() => {
                        if (onSubmit) {
                            onSubmit();
                        }
                        close();
                    }}
                >
                    {t("shared.confirm.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
